<template>
  <div class="add-or-update-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ readonly ? '查看房间' : isAdd ? '添加房间' : '编辑房间' }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="goBack"
          >返回列表</el-button>
      </div>
      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="100px"
        label-position="right"
        :disabled="readonly"
        class="room-form">
        <el-form-item label="房间名称" prop="roomName">
          <el-input v-model="dataForm.roomName" placeholder="请输入房间名称"></el-input>
        </el-form-item>
        <el-form-item label="楼层" prop="floor">
          <el-input v-model="dataForm.floor" placeholder="请输入楼层"></el-input>
        </el-form-item>
        <el-form-item label="面积(㎡)" prop="size">
          <el-input-number v-model="dataForm.size" :min="1" :max="1000" :precision="2" :step="0.1"></el-input-number>
        </el-form-item>
        <el-form-item label="容纳人数" prop="capacity">
          <el-input-number v-model="dataForm.capacity" :min="1" :max="200" :precision="0" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="dataForm.status" placeholder="请选择状态">
            <el-option label="可用" value="可用"></el-option>
            <el-option label="维修中" value="维修中"></el-option>
            <el-option label="停用" value="停用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房间类型" prop="type">
          <el-select v-model="dataForm.type" placeholder="请选择房间类型">
            <el-option label="团体课房间" value="团体课房间"></el-option>
            <el-option label="私教房间" value="私教房间"></el-option>
            <el-option label="多功能房间" value="多功能房间"></el-option>
            <el-option label="器械区" value="器械区"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备设施" prop="facilities">
          <el-checkbox-group v-model="dataForm.facilities">
            <el-checkbox label="跑步机">跑步机</el-checkbox>
            <el-checkbox label="健身单车">健身单车</el-checkbox>
            <el-checkbox label="举重设备">举重设备</el-checkbox>
            <el-checkbox label="瑜伽垫">瑜伽垫</el-checkbox>
            <el-checkbox label="镜面墙">镜面墙</el-checkbox>
            <el-checkbox label="音响系统">音响系统</el-checkbox>
            <el-checkbox label="空调">空调</el-checkbox>
            <el-checkbox label="电视">电视</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="房间简介" prop="description">
          <el-input
            type="textarea"
            v-model="dataForm.description"
            placeholder="请输入房间简介"
            :rows="4"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="房间图片" prop="imageUrl">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload">
            <img v-if="dataForm.imageUrl" :src="dataForm.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">支持JPG、PNG格式，不超过2MB</div>
        </el-form-item>
        <el-form-item v-if="!readonly">
          <el-button type="primary" @click="submitForm">{{ isAdd ? '立即创建' : '更新' }}</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadUrl: this.$http.baseURL + 'file/upload',
      uploadHeaders: {
        token: this.$cookie && this.$cookie.get ? this.$cookie.get('token') : ''
      },
      dataForm: {
        id: 0,
        roomName: '',
        floor: '',
        size: 40,
        capacity: 20,
        status: '可用',
        type: '',
        facilities: [],
        description: '',
        imageUrl: ''
      },
      dataRule: {
        roomName: [
          { required: true, message: '房间名称不能为空', trigger: 'blur' }
        ],
        floor: [
          { required: true, message: '楼层不能为空', trigger: 'blur' }
        ],
        size: [
          { required: true, message: '面积不能为空', trigger: 'change' }
        ],
        capacity: [
          { required: true, message: '容纳人数不能为空', trigger: 'change' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'change' }
        ],
        type: [
          { required: true, message: '房间类型不能为空', trigger: 'change' }
        ]
      },
      readonly: false,
      isAdd: true
    }
  },
  created() {
    const id = this.$route.query.id
    if (id) {
      this.isAdd = false
      this.dataForm.id = id
      this.getRoomInfo()
    }
    
    if (this.$route.query.readonly === 'true') {
      this.readonly = true
    }
  },
  methods: {
    getRoomInfo() {
      this.$http({
        url: `/room/info/${this.dataForm.id}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const roomInfo = data.room
          
          // 合并数据
          Object.keys(this.dataForm).forEach(key => {
            if (roomInfo[key] !== undefined) {
              this.dataForm[key] = roomInfo[key]
            }
          })
          
          // 确保设施是数组
          if (typeof this.dataForm.facilities === 'string') {
            try {
              this.dataForm.facilities = JSON.parse(this.dataForm.facilities)
            } catch (e) {
              this.dataForm.facilities = this.dataForm.facilities.split(',')
            }
          }
        }
      })
    },
    handleUploadSuccess(res, file) {
      if (res && res.code === 0) {
        this.dataForm.imageUrl = res.url
      } else {
        this.$message.error('上传失败，请重试')
      }
    },
    beforeUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPGOrPNG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPGOrPNG && isLt2M
    },
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          // 准备提交的数据
          const submitData = {...this.dataForm}
          
          // 设施转为JSON字符串
          if (Array.isArray(submitData.facilities)) {
            submitData.facilities = JSON.stringify(submitData.facilities)
          }
          
          this.$http({
            url: `/room/${this.isAdd ? 'save' : 'update'}`,
            method: 'post',
            data: submitData
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: `${this.isAdd ? '新增' : '修改'}成功`,
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.goBack()
                }
              })
            } else {
              this.$message.error(data.msg || '操作失败')
            }
          })
        }
      })
    },
    resetForm() {
      if (this.isAdd) {
        this.$refs.dataForm.resetFields()
      } else {
        this.getRoomInfo()
      }
    },
    goBack() {
      this.$router.push('/room')
    }
  }
}
</script>

<style scoped>
.add-or-update-container {
  padding: 20px;
}
.room-form {
  width: 80%;
  margin: 0 auto;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.upload-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}
</style> 